import { reduce, valuesIn, has } from 'lodash'

import { createRoutine } from 'redux-saga-routines'
import { IBillingState } from './billing.interface'
const initialBillingState: IBillingState = {
  billings: [],
  error: false,
  loading: false,
  meta: {
    perPage: 0,
    totalPages: 0,
    totalResults: 0,
    curPage: 0
  }
}

export const getAllBillings = createRoutine('GET_ALL_BILLINGS')
export const getDetailedBillings = createRoutine('GET_DETAILED_BILLINGS')

export default function device(state = initialBillingState, action: any) {
  switch (action.type) {
    case getAllBillings.TRIGGER:
      return { ...state, loading: true, billings: [], error: false, success: false }
    case getAllBillings.SUCCESS: {
      let groupedBillings: any = reduce(action.payload.billings, (result, item) => {
        const patientId = '_' + item.patient.id
        if (!has(result, patientId)) {
          result[patientId] = Object.assign({}, item, { _subRows: [] })
        } else {
          result[patientId]._subRows.push(item)
        }
        return result
      }, {})

      groupedBillings = valuesIn(groupedBillings)

      return {
        ...state,
        loading: false,
        success: true,
        billings: groupedBillings,
        meta: action.payload.meta,
        error: false,
      }
    }
    case getAllBillings.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      }
    case getDetailedBillings.TRIGGER:
      return { ...state, loading: true, billings: [], error: false, success: false }
    case getDetailedBillings.SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        billings: action.payload.billings,
        meta: action.payload.meta,
        error: false,
      }
    case getDetailedBillings.FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      }
    default:
      return state
  }
}
